import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { createAboutNearbyHousesMapper, TMappedResponse } from './mappers';
import {
  fetchNearbyHousesExplanation,
  INearbyHousesExplanationRequest,
} from '../../../repositories/valuation-offer-history/v2/nearby-houses-explanation';
import { TAboutNearbyHousesData } from '../../../types/offerHistory';
import { IApplicationContext } from '../../../types/applicationContext';

export const fetchNearbyHousesInfo = async (
  context: IApplicationContext,
  { houseId }: IParams,
): Promise<TAboutNearbyHousesData> => {
  const parameters: INearbyHousesExplanationRequest = { houseId };

  try {
    const res = (await fetchNearbyHousesExplanation({
      httpApi: context.httpApi,
      parameters,
      mappers: createAboutNearbyHousesMapper(parameters),
    })) as TMappedResponse;

    if (res instanceof HttpBadStatusCodeError) {
      throw res;
    }

    return res;
  } catch (error) {
    if (error instanceof HttpBadStatusCodeError) {
      context.logger.debug('nearby-houses-explanation BadRequest', { details: error.printDetails() });
    } else {
      context.logger.error(error, { message: 'Error in nearby-houses-explanation', ...parameters });
    }

    throw error;
  }
};

export interface IParams {
  houseId: number;
}
